import { Component } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { signOut } from 'firebase/auth';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIcon
  ],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent {
  constructor(private auth: Auth, private router: Router) { }

  logout() {
    signOut(this.auth)
      .then(() => {
        this.router.navigate(['/login']); // Optional: Weiterleitung zur Login-Seite
      })
      .catch((error) => {
      });
  }
}